import {Event} from './Event';

export enum VideoStartFailedReason {
  PAGE_CLOSED = 'PAGE_CLOSED',
  PLAYER_ERROR = 'PLAYER_ERROR',
  TIMEOUT = 'TIMEOUT',
  UNKNOWN = 'UNKNOWN',
}

export function createVideoStartFailedReason(stateMachineEvent: string | undefined): VideoStartFailedReason {
  switch (stateMachineEvent) {
    case Event.ERROR:
      return VideoStartFailedReason.PLAYER_ERROR;
    case Event.UNLOAD:
      return VideoStartFailedReason.PAGE_CLOSED;
    case Event.MANUAL_SOURCE_CHANGE:
      return VideoStartFailedReason.PAGE_CLOSED;
    case Event.SOURCE_UNLOADED:
      return VideoStartFailedReason.PAGE_CLOSED;
    case Event.VIDEOSTART_TIMEOUT:
      return VideoStartFailedReason.TIMEOUT;

    default:
      return VideoStartFailedReason.UNKNOWN;
  }
}
